<button *ngIf="showButton" type="button" class="btn btn-secondary grid-button" (click)="openFeedbackClicked()">
  <i class="material-icons" >assignment</i>
</button>
<div *ngIf="!showButton"></div>
